import { render, staticRenderFns } from "./addCustomCategory.vue?vue&type=template&id=2c5da64d&scoped=true"
import script from "./addCustomCategory.vue?vue&type=script&lang=js"
export * from "./addCustomCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5da64d",
  null
  
)

export default component.exports